document.addEventListener("DOMContentLoaded", function () {
    let flkty;
    const carousel = document.querySelector('.carousel');
    const flickityOptions = {
        cellSelector: '.carousel__cell', // This will be updated based on width
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        autoPlay: 4000,
        cellAlign: 'left',
        contain: true,
        pauseAutoPlayOnHover: false,
        lazyLoad: 4,
        adaptiveHeight: true,
        imagesLoaded: true,
        dragThreshold: 5,
        initialIndex: 0,
        arrowShape: "M32.7,15.9c1.4-1.4,3.6-1.4,5,0c1.4,1.4,1.4,3.6,0,5L12.1,46.4h84.3c2,0,3.5,1.6,3.5,3.5c0,2-1.6,3.6-3.5,3.6H12.1  l25.6,25.5c1.4,1.4,1.4,3.7,0,5c-1.4,1.4-3.7,1.4-5,0L1.1,52.5c-1.4-1.4-1.4-3.6,0-5L32.7,15.9z"
    };

    function initializeFlickity(cellSelector) {
        if (flkty) {
            flkty.destroy();
        }

        flickityOptions.cellSelector = cellSelector;
        flkty = new Flickity('.carousel', flickityOptions);

        // Ensure autoplay resumes after clicking arrows
        const buttons = document.querySelectorAll('.flickity-button');
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                flkty.player.play();
            });
        });

        // Accessibility Fix: Manage tabindex for focusable elements in hidden slides
        flkty.on('change', () => {
            const slides = document.querySelectorAll('.carousel__cell');
            slides.forEach(slide => {
                const isHidden = slide.getAttribute('aria-hidden') === 'true';
                const focusableElements = slide.querySelectorAll('a, button, input, [tabindex]');
                focusableElements.forEach(el => {
                    if (isHidden) {
                        el.setAttribute('tabindex', '-1');
                    } else {
                        el.removeAttribute('tabindex');
                    }
                });
            });
        });
    }

    // Manage dynamic cellSelector based on screen width
    let lastWidth = window.innerWidth;
    const threshold = 100;

    function updateCarouselBasedOnWidth() {
        const cellSelector = window.innerWidth <= 767
            ? '.carousel__cell, .carousel__cell_video'
            : '.carousel__cell, .carousel__cell_video';

        initializeFlickity(cellSelector);
    }

    // Initial setup on DOM content loaded
    updateCarouselBasedOnWidth();

    // Optimized resize handler
    function handleResize() {
        const currentWidth = window.innerWidth;

        // Check if the difference between current and last width exceeds threshold
        if (Math.abs(currentWidth - lastWidth) >= threshold) {
            updateCarouselBasedOnWidth();
            lastWidth = currentWidth;
        }
    }

    // Add resize event listener
    window.addEventListener('resize', handleResize);
});
